@use "../../../sass/global/global" as *;

// stylelint-disable selector-max-compound-selectors
ux-iws-stateful-table .ux-mobile-table ux-accordion {
    position: relative;

    .ux-w-status__text {
        display: inline;
    }

    // mobile styles for textAndDate table header
    .ux-iws-table-header--text-and-date {
        left: 75px;
        position: absolute;
    }

    .ux-iws-table-header__date {
        background: var(--ux-button-selected-bg-color);
        border-radius: 5px;
        color: var(--ux-button-selected-text-color);
        margin-left: 10px;
        padding: 5px 10px;
        text-align: center;

        &__month {
            font-size: 1.5em;
            font-weight: bold;
            line-height: 1em;
        }
    }
}

.ux-iws-stateful-table__header--long-label {
    display: inline-block;
    max-width: 220px;
    white-space: initial;
}

.ux-iws-stateful-table__cell--machine-name {
    color: $color-gray-text;
}

.ux-iws-stateful-table__cell--flex {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.ux-iws-stateful-table__cell--line-height {
    line-height: 19px;
}

/* stylelint-disable max-nesting-depth */
ux-table {
    .order-tracking {
        td {
            &::before,
            &::after {
                content: "";
                left: -1px;
                width: calc(100% + 2px);
                height: 3px;
                background-color: $color-blue-headline;
                position: absolute;
                z-index: 1;
            }

            &::before {
                top: 0;
            }

            &::after {
                bottom: 0;
            }

            &:not(:first-of-type) {
                position: relative;
            }

            &:first-of-type {
                border-left: 3px solid $color-blue-headline !important;
                padding-top: 45px;

                &::before {
                    top: -1px;
                }
            }

            &:last-of-type {
                border-right: 3px solid $color-blue-headline !important;
            }

            .order-tracking-bar {
                top: 0;
                left: 0;
                width: 100%;
                background-color: $color-blue-headline;
                color: $color-white;
                padding: 5px 20px;
                position: absolute;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    &:not(:has(.ux-table--is-fixed)) {
        .order-tracking {
            border: 3px solid $color-blue-headline;

            td {
                position: relative;

                &::before,
                &::after {
                    content: none;
                }
            }
        }
    }
}

/* stylelint-enable max-nesting-depth */

ux-mobile-table {
    .order-tracking-bar {
        background-color: $color-blue-headline;
        color: $color-white;
        margin-bottom: 10px;
        padding: 3px 10px 2px;
        width: max-content;
    }
}
